/**
 * WaveCRM Auth — Login Page JS
 * Dark mode, password toggle, loading state, caps lock, offline, haptics
 */

import { WebHaptics } from 'web-haptics';

document.addEventListener('DOMContentLoaded', function () {
    const haptics = new WebHaptics();

    const form = document.getElementById('login-form');
    const emailInput = document.getElementById('email');
    const passwordInput = document.getElementById('password');
    const toggleBtn = document.getElementById('toggle-password');
    const eyeOpen = document.getElementById('eye-icon-open');
    const eyeClosed = document.getElementById('eye-icon-closed');
    const capsWarning = document.getElementById('caps-warning');
    const submitBtn = document.getElementById('submit-btn');
    const submitText = document.getElementById('submit-text');
    const submitSpinner = document.getElementById('submit-spinner');
    const offlineMsg = document.getElementById('offline-msg');

    // ── Dark Mode Toggle ──
    var themeToggle = document.getElementById('theme-toggle');
    var themeSun = document.getElementById('theme-sun');
    var themeMoon = document.getElementById('theme-moon');

    function updateThemeIcons() {
        var isDark = document.documentElement.classList.contains('dark');
        if (themeSun && themeMoon) {
            themeSun.classList.toggle('hidden', !isDark);
            themeMoon.classList.toggle('hidden', isDark);
        }
        // Update theme-color meta for mobile browsers
        var meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.content = isDark ? '#111827' : '#F5F7FA';
    }

    if (themeToggle) {
        themeToggle.addEventListener('click', function () {
            var isDark = document.documentElement.classList.toggle('dark');
            localStorage.setItem('wcrm-theme', isDark ? 'dark' : 'light');
            updateThemeIcons();
            haptics.trigger('light');
        });
    }

    updateThemeIcons();

    // ── Password Visibility Toggle ──
    if (toggleBtn && passwordInput) {
        toggleBtn.addEventListener('click', function () {
            var isPassword = passwordInput.type === 'password';
            passwordInput.type = isPassword ? 'text' : 'password';
            toggleBtn.setAttribute('aria-label', isPassword ? 'Jelszó elrejtése' : 'Jelszó megjelenítése');

            if (eyeOpen && eyeClosed) {
                eyeOpen.classList.toggle('hidden', !isPassword);
                eyeClosed.classList.toggle('hidden', isPassword);
            }

            haptics.trigger('light');
        });
    }

    // ── Caps Lock Detection ──
    if (passwordInput && capsWarning) {
        passwordInput.addEventListener('keyup', function (e) {
            if (e.getModifierState && e.getModifierState('CapsLock')) {
                capsWarning.style.opacity = '1';
                capsWarning.style.visibility = 'visible';
            } else {
                capsWarning.style.opacity = '0';
                capsWarning.style.visibility = 'hidden';
            }
        });
    }

    // ── Form Submit — Loading State ──
    if (form && submitBtn) {
        form.addEventListener('submit', function () {
            haptics.trigger('light');

            submitBtn.disabled = true;
            submitBtn.classList.add('opacity-80', 'cursor-not-allowed');

            if (submitText) submitText.textContent = 'Belépés...';
            if (submitSpinner) submitSpinner.classList.remove('hidden');
        });
    }

    // ── Offline Detection ──
    function updateOnlineStatus() {
        if (!submitBtn || !offlineMsg) return;

        if (!navigator.onLine) {
            submitBtn.disabled = true;
            submitBtn.classList.add('opacity-50', 'cursor-not-allowed');
            offlineMsg.classList.remove('hidden');
        } else {
            submitBtn.disabled = false;
            submitBtn.classList.remove('opacity-50', 'cursor-not-allowed', 'opacity-80');
            offlineMsg.classList.add('hidden');
        }
    }

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    updateOnlineStatus();

    // ── Haptic Feedback on Page Load Alerts ──
    var authError = document.querySelector('[data-auth-error]');
    var sessionExpired = document.querySelector('[data-session-expired]');
    var accountLocked = document.querySelector('[data-account-locked]');

    if (accountLocked) {
        haptics.trigger('warning');
    } else if (authError) {
        haptics.trigger('error');
        var card = document.querySelector('.auth-card');
        if (card) {
            card.classList.add('auth-card-shake');
            card.addEventListener('animationend', function () {
                card.classList.remove('auth-card-shake');
            }, { once: true });
        }
    } else if (sessionExpired) {
        haptics.trigger('nudge');
    }

    // ── Reset form state on bfcache restore (browser back button) ──
    window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.classList.remove('opacity-80', 'opacity-50', 'cursor-not-allowed');
            }
            if (submitText) submitText.textContent = 'Belépés';
            if (submitSpinner) submitSpinner.classList.add('hidden');
        }
    });

    // ── Auto-focus first empty field ──
    if (emailInput && !emailInput.value) {
        emailInput.focus();
    } else if (passwordInput && emailInput && emailInput.value) {
        passwordInput.focus();
    }
});
